import React from "react";

export const Calendar = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
        <path
            stroke="#084C7C"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12.858 2.857v2.858M7.144 2.857v2.858M3.572 8.572H16.43M5.001 4.286h10c.789 0 1.428.64 1.428 1.429v10c0 .788-.64 1.428-1.428 1.428H5c-.79 0-1.429-.64-1.429-1.428v-10c0-.79.64-1.429 1.429-1.429z"
        />
    </svg>
);

export const Check = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
        <path
            stroke="#084C7C"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M17.143 9.347v.657c0 1.54-.5 3.04-1.422 4.273-.922 1.234-2.218 2.136-3.696 2.573-1.477.437-3.055.384-4.5-.15-1.445-.533-2.679-1.52-3.517-2.812-.838-1.292-1.236-2.82-1.135-4.358.101-1.537.697-3 1.697-4.17 1.001-1.171 2.354-1.988 3.856-2.327 1.503-.34 3.075-.184 4.481.443m4.236.814L10 11.44 7.857 9.297"
        />
    </svg>
);

export const List = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
        <path
            fill="#084C7C"
            d="M7.143 6.214h9.286v-1H7.143v1zm0 4.286h9.286v-1H7.143v1zm0 4.286h9.286v-1H7.143v1zM3.786 5.714c0 .119-.096.215-.214.215v1c.67 0 1.214-.544 1.214-1.215h-1zm-.214.215c-.119 0-.215-.096-.215-.215h-1c0 .67.544 1.215 1.215 1.215v-1zm-.215-.215c0-.118.096-.214.215-.214v-1c-.67 0-1.215.544-1.215 1.214h1zm.215-.214c.118 0 .214.096.214.214h1c0-.67-.544-1.214-1.214-1.214v1zm.214 4.5c0 .118-.096.214-.214.214v1c.67 0 1.214-.543 1.214-1.214h-1zm-.214.214c-.119 0-.215-.096-.215-.214h-1c0 .67.544 1.214 1.215 1.214v-1zM3.357 10c0-.118.096-.214.215-.214v-1c-.67 0-1.215.543-1.215 1.214h1zm.215-.214c.118 0 .214.096.214.214h1c0-.67-.544-1.214-1.214-1.214v1zm.214 4.5c0 .118-.096.214-.214.214v1c.67 0 1.214-.544 1.214-1.214h-1zm-.214.214c-.119 0-.215-.096-.215-.214h-1c0 .67.544 1.214 1.215 1.214v-1zm-.215-.214c0-.119.096-.215.215-.215v-1c-.67 0-1.215.544-1.215 1.215h1zm.215-.215c.118 0 .214.096.214.215h1c0-.67-.544-1.215-1.214-1.215v1z"
        />
    </svg>
);

export const Map = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
        <path
            stroke="#084C7C"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16.43 8.571c0 5-6.43 9.286-6.43 9.286S3.573 13.57 3.573 8.57c0-1.705.678-3.34 1.883-4.546 1.206-1.205 2.84-1.882 4.546-1.882 1.705 0 3.34.677 4.546 1.882 1.205 1.206 1.882 2.841 1.882 4.546z"
        />
        <path
            stroke="#084C7C"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10 10.714c1.184 0 2.144-.96 2.144-2.143 0-1.183-.96-2.143-2.143-2.143-1.184 0-2.143.96-2.143 2.143 0 1.184.96 2.143 2.143 2.143z"
        />
    </svg>
);

export const ScriptNow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" fill="none" viewBox="0 0 14 16">
        <path
            fill="#000"
            d="M5.719 8.93C4.03 7.823 3.187 6.53 3 6.02l.61-.859c.078.127.328.477.703.954.498.635 1.64 1.527 3 2.338C8.4 9.102 9.89 9.583 10.5 9.79l-.75 1.05c-.703-.064-2.344-.802-4.031-1.909z"
        />
        <path
            fill="#FFA26B"
            fillRule="evenodd"
            d="M2.043 15.073c2.174.724 5.51-1.15 7.92-4.61 2.525-3.626 3.146-7.716 1.547-9.536.275.091.53.224.764.4 2.082 1.574 1.568 6.01-1.147 9.908-2.715 3.898-6.604 5.783-8.685 4.21-.146-.11-.279-.234-.399-.372z"
            clipRule="evenodd"
        />
        <path
            fill="#5789A3"
            fillRule="evenodd"
            d="M11.51.926C9.335.203 6 2.076 3.59 5.538 1.065 9.163.444 13.253 2.043 15.073c-.275-.091-.531-.224-.765-.4-2.08-1.574-1.567-6.01 1.148-9.908C5.141.867 9.03-1.018 11.11.555c.146.11.28.234.4.371z"
            clipRule="evenodd"
        />
    </svg>
);

export const TextBook = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
        <path
            stroke="#084C7C"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10 6.428c0-.757-.3-1.484-.837-2.02-.535-.536-1.262-.837-2.02-.837H2.857v10.715h5c.569 0 1.114.225 1.516.627.402.402.627.947.627 1.515m0-10v10m0-10c0-.757.301-1.484.837-2.02s1.263-.837 2.02-.837h4.286v10.715h-5c-.568 0-1.113.225-1.515.627-.402.402-.628.947-.628 1.515"
        />
    </svg>
);

export const MyAccount = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path
            stroke="#084C7C"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 14.571c1.421 0 2.572-1.151 2.572-2.571 0-1.42-1.151-2.572-2.571-2.572-1.42 0-2.572 1.152-2.572 2.572 0 1.42 1.152 2.571 2.572 2.571z"
        />
        <path
            stroke="#084C7C"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M18.344 14.571c-.114.259-.148.546-.098.824.05.278.183.534.38.736l.052.052c.16.159.286.348.372.556.086.208.13.431.13.657 0 .225-.044.448-.13.656-.086.208-.213.397-.372.556-.16.16-.348.286-.556.372-.209.087-.432.131-.657.131-.225 0-.448-.044-.656-.13-.209-.087-.398-.213-.557-.373l-.051-.051c-.202-.198-.459-.33-.737-.38-.278-.051-.565-.017-.823.097-.254.109-.47.29-.622.52-.152.23-.234.499-.235.774v.146c0 .455-.18.89-.502 1.212-.322.322-.758.502-1.213.502-.454 0-.89-.18-1.212-.502-.321-.321-.502-.757-.502-1.212v-.077c-.007-.284-.098-.559-.263-.79-.166-.23-.396-.406-.663-.504-.258-.114-.545-.148-.823-.098-.278.05-.535.183-.737.38l-.051.052c-.16.16-.348.286-.556.372-.209.086-.432.13-.657.13-.225 0-.448-.044-.656-.13-.208-.086-.398-.213-.557-.372-.16-.16-.286-.348-.372-.556-.086-.208-.13-.432-.13-.657 0-.225.044-.448.13-.656.086-.208.213-.398.372-.557l.052-.051c.197-.202.33-.459.38-.737.05-.278.017-.565-.097-.823-.11-.254-.29-.47-.52-.622-.23-.152-.499-.234-.775-.235h-.145c-.455 0-.891-.18-1.213-.502-.321-.322-.502-.758-.502-1.213 0-.454.18-.89.502-1.212.322-.321.758-.502 1.213-.502h.077c.283-.006.559-.098.79-.263.23-.166.406-.396.504-.663.114-.258.148-.545.098-.823-.05-.278-.183-.535-.38-.737l-.052-.051c-.16-.16-.286-.348-.372-.556-.087-.208-.131-.432-.131-.657 0-.225.044-.448.13-.656.087-.208.213-.397.373-.557.159-.16.348-.286.556-.372.208-.086.431-.13.657-.13.225 0 .448.044.656.13.208.086.397.213.556.372l.052.052c.202.197.458.33.736.38.279.05.565.017.824-.097h.068c.254-.11.47-.29.622-.52.153-.23.235-.499.236-.775v-.145c0-.455.18-.891.502-1.213.321-.321.757-.502 1.212-.502.455 0 .89.18 1.212.502.322.322.502.758.502 1.213v.077c.001.276.083.545.235.775.152.23.369.41.622.519.259.114.546.148.824.098.278-.05.534-.183.736-.38l.052-.052c.159-.16.348-.286.556-.372.208-.087.431-.131.657-.131.225 0 .448.044.656.13.208.087.397.213.556.373.16.159.286.348.372.556.087.208.131.431.131.657 0 .225-.044.448-.13.656-.087.208-.213.397-.373.556l-.051.052c-.198.202-.33.458-.38.737-.051.278-.017.564.097.823v.068c.109.254.29.47.52.622.23.153.499.234.774.236h.146c.455 0 .89.18 1.212.502.322.321.502.757.502 1.212 0 .454-.18.89-.502 1.212-.321.322-.757.502-1.212.502h-.077c-.276.001-.545.083-.775.235-.23.153-.41.369-.52.622z"
        />
    </svg>
);

export const LogOut = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path
            stroke="#084C7C"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.428 19.715H5.999c-.454 0-.89-.18-1.212-.502-.321-.322-.502-.758-.502-1.213V6c0-.454.18-.89.502-1.212.322-.321.758-.502 1.212-.502h3.429m6 12L19.714 12m0 0l-4.286-4.285M19.714 12H9.428"
        />
    </svg>
);

export const Home = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
            <path
                stroke="#084C7C"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.858 17.143V10h4.286v7.143M3.572 7.857l6.429-5 6.428 5v7.858c0 .378-.15.742-.418 1.01s-.631.418-1.01.418H5c-.379 0-.742-.15-1.01-.418s-.419-.632-.419-1.01V7.857z"
            />
        </svg>
    );
};

export const RewardIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6.564 10.215l-.778 5.856L9 14.143l3.214 1.928-.778-5.863m2.064-3.78c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z"
        />
    </svg>
);

export const HeartAgeFlag = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path
                stroke="#372168"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.143 14.572s.857-.858 3.428-.858c2.572 0 4.286 1.715 6.858 1.715 2.571 0 3.428-.857 3.428-.857V4.286s-.857.857-3.428.857c-2.572 0-4.286-1.714-6.858-1.714-2.571 0-3.428.857-3.428.857v10.286zm0 0v6"
            />
        </svg>
    );
};
